module.exports = __webpack_public_path__ + "img/9791130631837.751254c7.jpg";